import React, { useEffect, useRef } from 'react';

const CustomCursor = () => {
    const smallCursorRef = useRef(null);
    const ringCursorRef = useRef(null);

    useEffect(() => {
        const smallCursor = smallCursorRef.current;
        const ringCursor = ringCursorRef.current;

        let ringX = 0;
        let ringY = 0;
        let mouseX = 0;
        let mouseY = 0;
        let smallX = 0; // Small cursor's position
        let smallY = 0; // Small cursor's position
        let movingTimer;

        const updatePositions = () => {
            // Increase speed for the small cursor
            smallX += (mouseX - smallX) * 0.3; 
            smallY += (mouseY - smallY) * 0.3;

            // Smooth transition for the ring cursor
            ringX += (smallX - ringX) * 0.05; 
            ringY += (smallY - ringY) * 0.05;

            // Apply transformations
            if (ringCursor) {
                ringCursor.style.transform = `translate3d(${ringX}px, ${ringY}px, 0)`;
            }

            if (smallCursor) {
                smallCursor.style.transform = `translate3d(${smallX}px, ${smallY}px, 0)`;
            }

            requestAnimationFrame(updatePositions);
        };

        const handleMouseMove = (event) => {
            mouseX = event.clientX;
            mouseY = event.clientY;

            // Reset moving timer
            clearTimeout(movingTimer);
            movingTimer = setTimeout(() => {}, 0); // Adjust delay if needed
        };

        window.addEventListener('mousemove', handleMouseMove);
        requestAnimationFrame(updatePositions);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return (
        <div>
            <div
                ref={smallCursorRef}
                className="cursor--small fixed rounded-full pointer-events-none transition-transform duration-300 hidden md:block"
                style={{
                    width: '9px',
                    height: '9px',
                    left: '-3px',
                    top: '-2px',
                    zIndex: 11000,
                    backgroundColor: 'rgba(5, 32, 243, 0.8)',
                }}
                aria-hidden="true"
            ></div>

            <div
                ref={ringCursorRef}
                className="cursor--ring fixed pointer-events-none transition-transform duration-150 hidden md:block"
                style={{
                    width: '40px',
                    height: '40px',
                    left: '-19px',
                    top: '-19px',
                    zIndex: 11000,
                    border: '3px solid rgba(5, 32, 250, 0.8)',
                    borderRadius: '50%',
                }}
                aria-hidden="true"
            ></div>
        </div>
    );
};

export default CustomCursor;


